/**
 * @TODO
 * While forms are being refactored this is a temporary solution for not breaking plugins.
 * To be removed after full migration and plugin fixes
 */
export const parseCustomErrors = (
  errors,
  prefix = '',
  isArray = false,
  errorMap = {},
) => {
  Object.entries(errors).map(([key, error]) => {
    let fieldKey = key;
    if (isArray) fieldKey = `${prefix}[${key}]`;
    else if (prefix) fieldKey = `${prefix}.${key}`;

    if (typeof error === 'object') {
      parseCustomErrors(error, fieldKey, Array.isArray(error), errorMap);
    } else {
      errorMap[fieldKey] = error;
    }
  });
  return errorMap;
};
